import React, { useState, useEffect, useRef } from "react";
import { Form} from "react-bootstrap";
import Button from "@material-ui/core/Button";
import styles2 from "../css/COLUMN.module.css";
import ElemDeleteControl from "./ElemDeleteControlWrapper";
import { makeStyles } from "@material-ui/core/styles";
import styles3 from "../css/Button.module.css";
import { isColor, getHooksId } from "../../Resources/globalFunctions";
import PrepareCSSClass from "../../components/IFormDesignerLayout/PrepareCSSClass";
import QuickTools from "../../ReusableComponents/QuickTools/QuickTools";
import { triggerEventCalls } from "../../ReusableComponents/Events/EventExecutionLogic";
import { getSuggestedId } from "../../components/IFormDesignerLayout/Logic/UserIdLogic";
import CustomizedAlert from "../../ReusableComponents/Alert/CustomizedAlert";
import {useDispatch } from "../../Redux";
import Tooltip from "../../ReusableComponents/Tooltip/Tooltip";
import ButtonSubFormDialog from "../../components/IFormDesignerLayout/IFormDesignerComponents/ButtonProperties/ButtonSubForm";
import { handleDisplayProperty, encrypt, decryptMessage, updatePartialJSON, loadArabicImage, getTabIndex } from "../../components/IFormDesignerLayout/IFormDesignerLogic";
import {
  GetState,
  GetStateFromData,
} from "../../components/CustomHooks/CustomHooks";
import cloneDeep from "lodash-es/cloneDeep";
import { functions, renderExecuteServerEventAPIData } from "../../components/IFormDesignerLayout/ApplicationAPI/applicationApi";
import axios from "../../axios";
import CanvasSubform from "../../components/IFormDesignerLayout/IFormDesignerComponents/CanvasSubform";
import PickListPopup from "../../components/IFormDesignerLayout/IFormDesignerComponents/PicklistProperties/PickListPopup";
import { updateGridContexts, updateStateInRedux, updatesubFormMetaDataWithoutRender} from "../../Redux/Actions/FormStateActions";
import uuid from "react-uuid";
import {
  getWIToken,getGdToken,
} from "../../components/IFormDesignerLayout/IFormDesignerLogic";
import { formStateStore } from "../../Redux/Store/store";
import useRender from "../../components/CustomHooks/useRender";
import { handleWinObjects } from "../../components/IFormDesignerLayout/ReUsableLogics";
import { Menu, MenuItem } from "@material-ui/core";
import DropdownIcon from "../../Icons/DropdownIcon";

const useStyles = makeStyles({
  buttonLabel: {
    "& .MuiButton-label": {
      fontFamily: (styles) =>
          !styles.FontFamily || styles?.FontFamily === "" || styles?.FontFamily === "Select"
          ? styles?.ControlFontFamily
          : styles?.FontFamily,
      fontSize: (styles) =>
      !styles.FontSize || styles?.FontSize === "" || styles?.FontSize === "Select"
          ? styles?.ControlFontSize
          : styles?.FontSize,
      display: "contents",
    },
  },
});

const BUTTON = (props) => {
   const activeTabIndex = getTabIndex(props?.data);
  const contexts = GetStateFromData(props.containerId);
  const gridContexts = GetStateFromData(props.containerId, "data2");

  const { controlSelected, tempCanWidth, resetProperties } = GetState(
    "controlSelected",
    "tempCanWidth",
    "resetProperties"
  );

  const { openCanvasForPreview } = gridContexts.gridStates;

  const dispatch = useDispatch();
  const isSubformInPage = props?.isSubformInPage || false;

  const reduxContexts = contexts;
  const {
    updateJson,
    IdPrecedence,
    modeReadOrWrite,
    openQuickToolFor,
    deleteControl,
    applyChanges,
    device,
    formState2,
    setSubFormState,
    subFormStateJson,
    builderMode,
    imageBaseURL,
  } = contexts.contexts;
  const conditionalQuickToolOpening =
    props.id === openQuickToolFor ? true : false;
  const [renderElem, updatedData, isEqual] = useRender(props?.data);
    if (updatedData && !isEqual)
    props.data = updatedData;
  console.log("renderElem button", renderElem, props?.data);

  const { updatedComponentInFormState } = updateJson;
  const actualControlId = props.data.id;
  let mappingId = props.data["style"] && props.data["style"]["MappingId"];
  let userDefinedId = props.data["style"] && props.data["style"]["CustomId"];
  let userDefinedControlId = getSuggestedId(
    actualControlId,
    mappingId,
    userDefinedId,
    IdPrecedence
  );
  const themeData = formState2.theme;
  const controlThemeData = themeData?.["ButtonStyle"];
  const [open, setOpen] = useState(conditionalQuickToolOpening);
  const [mobileDisplay, setMobileDisplay] = useState(true);
  const [tabDisplay, setTabDisplay] = useState(true);
  const [disableBtn, setDisableBtn] = useState(false);
  const [windowData, windoeSetData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [getPicklistDataPopup, setGetPicklistDataPopup] = useState(null);
  const buttonOptionsJSON = props?.data?.isButtonDropDown && props?.data?.buttonOptionsJSON ? props?.data?.buttonOptionsJSON : {};
  const buttonOptionsLabel = buttonOptionsJSON ? Object.keys(buttonOptionsJSON) : [];
  const [anchorEl, setAnchorEl] = useState(null);
  const openDropdown = Boolean(anchorEl);
  const handleDropdownClick = (event) => {
    setAnchorEl(elementRefrence.current || event.currentTarget);
  };
  const handleDropdownClose = () => {
    setAnchorEl(null);
  };
  const styles = {
    ...props?.data?.style,
    ...{
      ControlFontFamily:
        controlThemeData?.[
          (props?.data?.style.ButtonType || controlThemeData?.ControlStyle || "Primary") + "ButtonFontFamily"
        ] || "Open Sans",
      ControlFontSize:
        controlThemeData?.[
          (props?.data?.style.ButtonType || controlThemeData?.ControlStyle || "Primary") + "ButtonFontSize"
        ] || "14px",
    },
  };
  const classes = useStyles(styles);
  const elementRefrence = useRef(null);
  var data = props.data;
  const controlSpacing = themeData?.['Control Spacing'] || {};
  const buttonDefaultStyle = {
    "margin-bottom": "0px !important",
    "min-height": "32px",
    height: "fit-content !important",
    "font-size": "12px",
    "font-weight": "600",
    "font-family": "Open Sans",
    "font-style": "normal",
    "background-color":
      props?.data?.style?.["BackgroundColor"] ||
      controlThemeData?.["PrimaryButtonBackgroundColor"] ||
      "#0072C6",
    // "border-width": "1px",
    // "border-style": "solid",
    // "border-color": "#3D6CE9",
    color:
      props?.data?.style?.["FontColor"] ||
      controlThemeData?.["PrimaryButtonFontColor"] ||
      "#FFFFFF",
    "border-radius": "3px",
    "margin-top": "0px !important",
    "margin-right": "0px !important",
    buttonType: "Primary",
    "text-transform": "none",
    "word-break": "break-word",    
    "white-space": "break-spaces",
    padding: '0pt 8px !important',
  };

  let buttonDefault = {current : buttonDefaultStyle};
  const setbuttonDefault = (newStyle) => {
    buttonDefault.current = { ...buttonDefault.current, ...newStyle };    
  };

  let inlineStyle2 = {current :{
    minHeight: "55px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    boxSizing: "border-box",
    "padding-left": props.data?.style?.["SpacingLeft"],
    "padding-right": props.data?.style?.["SpacingRight"],
    "padding-top":props.data?.style?.["SpacingTop"],
    "padding-bottom": props.data?.style?.["SpacingBottom"],
  }};
  const setInlineStyle2 = (newStyle) => {
    inlineStyle2.current = { ...inlineStyle2.current, ...newStyle };    
  };
  let iconFile = {current: null};
  const setIconFile = (newStyle) => {
    iconFile.current = newStyle;    
  };

  const startMobile = useRef();
  const endMobile = useRef();
  const startTab = useRef();
  const endTab = useRef();

  useEffect(() => {
    let flag = false;
    if(props?.isSubForm && !props?.data?.isSubForm) {
    props.data.isSubForm = props?.isSubForm;
    flag = true;
    }
    if(props?.buttonId && props?.data?.buttonId !== props?.buttonId) {
    props.data.buttonId = props?.buttonId;
    flag = true;
    }
    // if(flag)
    //     updatePartialJSON(props.data.id,props.data);
  },[props?.isSubForm, props?.buttonId])

  useEffect(()=>{
    
    if(!props?.data?.eventSource || props?.data?.eventSource===undefined ){
      const controlJson= {...props?.data};
      controlJson.eventSource = uuid();

      updatePartialJSON(
        props?.data.id,
        controlJson
      );

      props.data.eventSource = controlJson.eventSource;
    }

  },[]);

  useEffect(()=>{
    if(props.previewmode && props?.data?.subform) {
      setSubFormState(props.data.subform);
    }
  },[JSON.stringify(props.data.subform)])

  useEffect(() => {
    if (formState2 && formState2.style) {
      startMobile.current = parseInt(
        formState2.style?.["Breakpoint"]?.["Mobile"]?.["StartValue"]
      );
      endMobile.current = parseInt(
        formState2.style?.["Breakpoint"]?.["Mobile"]?.["EndValue"]
      );
      startTab.current = parseInt(
        formState2.style?.["Breakpoint"]?.["Tab"]?.["StartValue"]
      );
      endTab.current = parseInt(
        formState2.style?.["Breakpoint"]?.["Tab"]?.["EndValue"]
      );
    }
  }, [
    formState2.style?.["Breakpoint"],
    formState2.style?.["Breakpoint"]?.["Mobile"],
    formState2.style?.["Breakpoint"]?.["Tab"],
  ]);

  useEffect(() => {
    if (props?.previewmode)
      handleDisplayProperty(
        props,
        device,
        setMobileDisplay,
        setTabDisplay,
        startMobile.current,
        endMobile.current,
        startTab.current,
        endTab.current
      );
  }, [
    props?.data?.style?.["MobileVisible"],
    props?.data?.style?.["TabsVisible"],
    device,
    endMobile,
    endTab,
    startMobile,
    startTab,
    tempCanWidth,
  ]);

  // useEffect(() => {
    // const enable = props?.data?.style?.Enable;

    if (
      controlThemeData &&
      controlThemeData["ControlStyle"] &&
      !props?.data?.style?.ButtonType
    ) {
      setbuttonDefault({ buttonType: controlThemeData["ControlStyle"] });

      if (controlThemeData["ControlStyle"] === "Text") {
        setbuttonDefault({
          "background-color": "unset",
          "border-color": "",
          "border-style": "none",
        });
      }
      if (controlThemeData["ControlStyle"] !== "Primary") {
        setbuttonDefault({ color: "#0072C6" });
      }
      if (controlThemeData["ControlStyle"] === "Secondary") {
        setbuttonDefault({
          "background-color": "#FFFFFF",
          "border-color": "#0072C6",
          "border-style": "solid",
        });
      }
      if (controlThemeData["ControlStyle"] === "Primary") {
        setbuttonDefault({
          "background-color":
            props.data.style["BackgroundColor"] ||
            controlThemeData?.[
              controlThemeData?.["ControlStyle"] + "ButtonBackgroundColor"
            ] ||
            "#0072C6",
          color: "#FFFFFF",
          "border-color": "",
          "border-style": "none",
        });
      }
    }

    if (
      controlThemeData &&
      controlThemeData[controlThemeData["ControlStyle"] + "ButtonFontSize"] &&
      !props.data.style["FontSize"]
    ) {
      setbuttonDefault({
        "font-size": `${
          controlThemeData?.[
            controlThemeData?.["ControlStyle"] + "ButtonFontSize"
          ]
        } !important`,
      });
    }
    if (
      controlThemeData &&
      controlThemeData[
        (props?.data?.style?.ButtonType || "Primary") + "ButtonFontSize"
      ] &&
      props.data.style["FontSize"] === "Select"
    ) {
      setbuttonDefault({
        "font-size": `${
          controlThemeData?.[
            controlThemeData?.["ControlStyle"] + "ButtonFontSize"
          ]
        } !important`,
      });
    }
    if (
      controlThemeData &&
      !controlThemeData[
        (props?.data?.style?.ButtonType || "Primary") + "ButtonFontSize"
      ] &&
      props.data.style["FontSize"] === "Select"
    ) {
      setbuttonDefault({
        "font-size": `14px !important`,
      });
    }
    if (
      controlThemeData &&
      controlThemeData[controlThemeData["ControlStyle"] + "ButtonFontWeight"] &&
      !props.data.style["FontWeight"]
    ) {
      setbuttonDefault({
        "font-weight":
          controlThemeData[
            buttonDefault.current.buttonType + "ButtonFontWeight"
          ],
      });
    }
    if (
      controlThemeData &&
      !controlThemeData[
        (controlThemeData["ControlStyle"] || "Primary") + "ButtonFontWeight"
      ] &&
      !props.data.style["FontWeight"]
    ) {
      setbuttonDefault({
        "font-weight": "300",
      });
    }
    if (
      controlThemeData &&      
      !props.data.style["FontStyle"]
    ) {
      setbuttonDefault({
        "font-style": "normal",
      });
    }
    if (
      controlThemeData &&
      controlThemeData[controlThemeData["ControlStyle"] + "ButtonFontFamily"] &&
      !props.data.style["FontFamily"]
    ) {
      setbuttonDefault({
        "font-family":
          controlThemeData[
            controlThemeData["ControlStyle"] + "ButtonFontFamily"
          ],
      });
    }
    if (
      controlThemeData &&
      !controlThemeData[
        (props.data.style.ButtonType || "Primary") + "ButtonFontFamily"
      ] &&
      !props.data.style["FontFamily"]
    ) {
      setbuttonDefault({
        "font-family": "Open Sans",
      });
    }
    if (
      controlThemeData &&
      controlThemeData[
        controlThemeData["ControlStyle"] + "ButtonBorderColor"
      ] &&
      controlThemeData["ControlStyle"] === "Secondary" &&
      !props.data.style["BorderColor"]
    ) {
      setbuttonDefault({
        "border-color":
          controlThemeData[
            controlThemeData["ControlStyle"] + "ButtonBorderColor"
          ],
      });
    }
    if (
      controlThemeData &&
      controlThemeData[
        controlThemeData["ControlStyle"] + "ButtonBorderWidth"
      ] &&
      controlThemeData["ControlStyle"] === "Secondary" &&
      !props.data.style["BorderWidth"]
    ) {
      setbuttonDefault({
        "border-width":
          controlThemeData[
            controlThemeData["ControlStyle"] + "ButtonBorderWidth"
          ],
      });
    }
    if (
      controlThemeData &&
      !controlThemeData[props?.data?.style?.ButtonType + "ButtonBorderWidth"] &&
      props?.data?.style?.ButtonType === "Secondary" &&
      props.data.style["BorderWidth"] === ""
    ) {
      setbuttonDefault({
        "border-width": "1px",
      });
    }
    if (
      controlThemeData &&
      controlThemeData[
        controlThemeData["ControlStyle"] + "ButtonBorderRadius"
      ] &&
      (controlThemeData["ControlStyle"] === "Secondary" ||
        controlThemeData["ControlStyle"] === "Primary") &&
      !props.data.style["CornerRadius"]
    ) {
      setbuttonDefault({
        "border-radius":
          controlThemeData[
            controlThemeData["ControlStyle"] + "ButtonBorderRadius"
          ],
      });
    }
    if (
      controlThemeData &&
      !controlThemeData[
        (props?.data?.style?.ButtonType || "Primary") + "ButtonBorderRadius"
      ] &&
      (props?.data?.style?.ButtonType === "Secondary" ||
        props?.data?.style?.ButtonType === "Primary") &&
      props.data.style["CornerRadius"] === ""
    ) {
      setbuttonDefault({
        "border-radius": "3px",
      });
    }
    if (
      controlThemeData &&
      controlThemeData[controlThemeData["ControlStyle"] + "ButtonFontColor"] &&
      !props.data.style["FontColor"]
    ) {
      setbuttonDefault({
        color:
          controlThemeData[
            controlThemeData["ControlStyle"] + "ButtonFontColor"
          ],
      });
    }
    if (
      controlThemeData &&
      controlThemeData[
        controlThemeData["ControlStyle"] + "ButtonBackgroundColor"
      ] &&
      controlThemeData["ControlStyle"] === "Primary" &&
      !props.data.style["BackgroundColor"]
    ) {
      setbuttonDefault({
        "background-color": isColor(
          controlThemeData[
            controlThemeData["ControlStyle"] + "ButtonBackgroundColor"
          ]
        ),
      });
    }
    if (
      controlThemeData["ControlStyle"] !== "Text" &&
      controlThemeData &&
      controlThemeData[
        controlThemeData["ControlStyle"] + "ButtonBorderRadius"
      ] &&
      !props.data.style["CornerRadius"]
    ) {
      setbuttonDefault({
        "border-radius":
          controlThemeData[
            controlThemeData["ControlStyle"] + "ButtonBorderRadius"
          ],
      });
    }
    if (
      props?.data?.style?.ButtonType !== "Text" &&
      controlThemeData &&
      !controlThemeData[
        (props?.data?.style?.ButtonType || "Primary") + "ButtonBorderRadius"
      ] &&
      !props.data.style["CornerRadius"]
    ) {
      setbuttonDefault({
        "border-radius": "3px",
      });
    }
  // }, [controlThemeData, cloneDeep(styles)]);

  // useEffect(() => {
    if (
      themeData &&
      themeData["BasicTheme"] &&
      themeData["BasicTheme"] &&
      !props.data.style["FontFamily"] &&
      !controlThemeData[controlThemeData["ControlStyle"] + "ButtonFontFamily"]
    ) {
      setbuttonDefault({
        "font-family": "Open Sans",
      });
    }

    if (
      themeData &&
      themeData["BasicTheme"] &&
      themeData["BasicTheme"]["FontFamily"] &&
      !props.data.style["FontFamily"] &&
      !controlThemeData[controlThemeData["ControlStyle"] + "ButtonFontFamily"]
    ) {
      setbuttonDefault({
        "font-family": themeData["BasicTheme"]["FontFamily"],
      });
    }
    if (
      themeData &&
      themeData["BasicTheme"] &&
      themeData["BasicTheme"]["FontSize"] &&
      !controlThemeData[controlThemeData["ControlStyle"] + "ButtonFontSize"]
    ) {
      setbuttonDefault({
        "font-size": `${themeData["BasicTheme"]["FontSize"]} !important`,
      });
    }
  // }, [themeData?.["BasicTheme"]]);

  // useEffect(() => {
    const ButtonType = data?.style?.ButtonType || "Primary";
    if (data && data.style && data.style.ButtonType) {
      setbuttonDefault({ buttonType: data.style.ButtonType });

      if (data.style.ButtonType === "Text") {
        setbuttonDefault({
          "background-color": "unset",
          "border-color": "",
          "border-style": "none",
        });
      }
      if (data.style.ButtonType !== "Primary") {
        setbuttonDefault({
          color:
            (controlThemeData &&
              controlThemeData[data.style.ButtonType + "ButtonFontColor"]) ||
            "#0072C6",
        });
      }
      if (data.style.ButtonType === "Secondary") {
        setbuttonDefault({
          "background-color": "unset",
          "border-color":
            (controlThemeData &&
              controlThemeData[data.style.ButtonType + "ButtonBorderColor"]) ||
            "#0072C6",
          "border-style": "solid",
        });
      }
      if (data.style.ButtonType === "Primary") {
        setbuttonDefault({
          "background-color":
            (controlThemeData &&
              controlThemeData[
                data.style.ButtonType + "ButtonBackgroundColor"
              ]) ||
            props.data.style["BackgroundColor"] ||
            "#0072C6",
          color:
            (controlThemeData &&
              controlThemeData[data.style.ButtonType + "ButtonFontColor"]) ||
            "#FFFFFF",
          "border-color": "",
          "border-style": "none",
        });
      }
    }
    if (
      data &&
      data.style &&
      data.style.StretchToColumnWidth &&
      data.style.StretchToColumnWidth === "true"
    ) {
      setbuttonDefault({ width: "100%" });
    } else  {
      setbuttonDefault({ width: "unset" });
    }
    if (
      props.data &&
      props.data.style &&
      props.data.style["FontFamily"] === "Select"
    ) {
      props.data.style["FontFamily"] = "";
    }
    if (
      props.data &&
      props.data.style &&
      props.data.style["BorderWidth"] === "Select"
    ) {
      props.data.style["BorderWidth"] = "";
    }
    if (
      props.data &&
      props.data.style &&
      props.data.style["CornerRadius"] === "Select"
    ) {
      props.data.style["CornerRadius"] = "";
    }

    if (props.data && props.data.style && props.data.style["FontFamily"]) {
      setbuttonDefault({ "font-family": props.data.style["FontFamily"] });
    }

    if (props.data && props.data.style && props.data.style["FontStyle"]) {
      setbuttonDefault({ "font-style": props.data.style["FontStyle"] });
    }
    if (
      props.data &&
      props.data.style &&
      props.data.style["FontSize"] &&
      props.data.style["FontSize"] !== "Select"
    ) {
      setbuttonDefault({
        "font-size": `${props?.data?.style?.["FontSize"]} !important`,
      });
    }

    if (props.data && props.data.style && props.data.style["FontWeight"]) {
      setbuttonDefault({ "font-weight": props.data.style["FontWeight"] });
    }
    if (props.data && props.data.style && props.data.style["FontColor"]) {
      setbuttonDefault({
        color: props.data.style["FontColor"],
      });
    }
    if (
      props.data &&
      props.data.style &&
      props.data.style["BackgroundColor"] &&
      ButtonType === "Primary"
    ) {
      setbuttonDefault({
        "background-color": props.data.style["BackgroundColor"],
      });
    }
    if (
      props.data &&
      props.data.style &&
      props.data.style["BorderColor"] &&
      ButtonType === "Secondary"
    ) {
      setbuttonDefault({
        "border-color": props.data.style["BorderColor"],
      });
    }
    if (
      props.data &&
      props.data.style &&
      props.data.style["BorderWidth"] &&
      ButtonType === "Secondary"
    ) {
      setbuttonDefault({ "border-width": props.data.style["BorderWidth"] });
    }

    if (props.data && props.data.style && props.data.style["CornerRadius"]) {
      setbuttonDefault({ "border-radius": props.data.style["CornerRadius"] });
    }

    if (props.data.style) {
      // Object.keys(props.data.style).forEach((keyName) => {
        if (
          props.data &&
          props.data.style &&
          props.data.style["FontSize"] &&
          props.data.style["FontSize"] !== "Select"
        ) {
          setbuttonDefault({
            "font-size": `${props?.data?.style?.["FontSize"]} !important`,
          });
        }

        // if (keyName === "ButtonHorizontalAlignment") {
        //   setInlineStyle2({ display: "flex" });
        //   setInlineStyle2({ "align-items": props.data.style[keyName] });
        // } else if (keyName === "ButtonVerticalAlignment") {
        //   setInlineStyle2({ ["display"]: "flex" });
        //   setInlineStyle2({ ["justify-content"]: props.data.style[keyName] });
        // }
      // });
    }

    if (props.data.style && props.data.style.icon !== undefined) {
      setIconFile(props.data.style.icon.file);
    }

    setInlineStyle2({ "padding-left": props.data?.style?.["SpacingLeft"]});

    setInlineStyle2({ "padding-right": props.data?.style?.["SpacingRight"]});

    setInlineStyle2({ "padding-top": props.data?.style?.["SpacingTop"]});

    setInlineStyle2({ "padding-bottom": props.data?.style?.["SpacingBottom"]});

    if (props.data.style["ButtonHorizontalAlignment"]){
      setInlineStyle2({ display: "flex" });
      setInlineStyle2({
        alignItems: props.data.style["ButtonHorizontalAlignment"],
      });
    }

    if (props.data.style["ButtonVerticalAlignment"]){
      setInlineStyle2({ ["display"]: "flex" });
      setInlineStyle2({
        justifyContent: props.data.style["ButtonVerticalAlignment"],
      });
    }
  // }, [cloneDeep(styles)]);

  var styleClassKey = `${props.id}` + "buttonDefaultStyle";
  var themeStyle = {};
  themeStyle[styleClassKey] = buttonDefault.current;

  var Editable = props.data.style.Enable;
  const refFlag8 = useRef(0);

  console.log("openQuickTool", openQuickToolFor);
  const newOpenQuickToolFor = openQuickToolFor;
  const refFlag7 = useRef(0);
  if (openQuickToolFor !== undefined && props.id === openQuickToolFor) {
    refFlag8.current = 1;
  }
  if (props.previewmode === undefined || props.previewmode === false) {
    refFlag7.current = 0;
  }
  if (props.previewmode && modeReadOrWrite === "r" && !props.data.style.isChangeFromAPI) {
    props.data.style.Enable = "false";
    Editable = "false";
    refFlag7.current = 1;
  }
  if (
    refFlag8.current === 1 &&
    props.data.style["Enable"] === "false" &&
    refFlag7.current === 0
  ) {
    Editable = "false";
    props.data.style.Enable = "false";
  }
  if (
    refFlag8.current === 1 &&
    props.data.style["Enable"] === "true" &&
    refFlag7.current === 0
  ) {
    Editable = "true";
    props.data.style.Enable = "true";
  }

  const [alertData, setAlertData] = useState({
    open: false,
    showConfirm: "showNotification",
  });
  let [openSub, setOpenSub] = useState(false);
  function showAlertConfirmNotifications(dataTobeSet) {
    setAlertData(dataTobeSet);
  }

  const executeRestApi = (Endpointname, id, eventtype, gdtoken, witoken) => {
    let jsonToSend = {
      restEndPoint: Endpointname,
      controlId: id,
      eventType: eventtype,
      gdtoken: gdtoken,
      witoken: witoken,
    };

    return axios.post("viewform/executeRestApi", jsonToSend, {
      withCredentials: true,
    });
  };

  async function subformInPreview(event) {
    if (
      props.data &&
      props.data.event &&
      props.data.event.Events &&
      props.data.event.Events["Click"]
    ) {
      await triggerEventCalls(
        event,
        { id: props?.data?.id },
        props.data.event,
        props.data.elem_type,
        showAlertConfirmNotifications,
        reduxContexts,
        props.containerId,
        props.data,
        "Click",
        undefined,
        updatedComponentInFormState,
        builderMode
      );

      if (props.data._getPicklistDataResult) {
        const result = props.data._getPicklistDataResult;
        const savedSelection = props.data._picklistSelection;
        setGetPicklistDataPopup({
          id: result.controlId,
          style: {
            BatchSize: result.batchSize,
            AllowMultipleSection: "false",
            PopupText: result.popupTitle || result.controlId,
            Picklist: savedSelection?.Picklist || "",
            PicklistSelected: savedSelection?.PicklistSelected,
            PicklistSelectedAllNames: {},
            PicklistSelectedAllData: {},
            PicklistSelectedAll: {},
          },
        });
        delete props.data._getPicklistDataResult;
      }
    }
    if (props.data.selectedEvent === 'subform' || props.data.selectedEvent === undefined) {   
      if(props.data.subform !==undefined) {
       if(props.previewmode && props.data?.subform?.pageStyle?.ButtonSubformOverlayType === "window") {
        axios.post('/tableAction/getControlJsonData', {
          gdtoken: getGdToken(), 
          witoken: getWIToken(),
          controlId: props.id, 
        }, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then(response => {
          const { elem_JSON } = response.data || {};
          if (elem_JSON) {
            var url = window.location; 
            let obj = {};
            if (window.resizeSubForm) {
              obj = window.resizeSubForm(props.data.id);
            }
            const width = obj.Width || 800;
            const height = obj.Height || 400;
            const left = (window.innerWidth / 2) - (width / 2) + window.screenX;
            const top = (window.innerHeight / 2) - (height / 2) + window.screenY;
            const windowFeatures = `width=${width},height=${height},left=${left},top=${top}`
            const url1 = `${url.origin}/afb_subform`;
            props.data.subform = structuredClone(elem_JSON);
            dispatch(updatesubFormMetaDataWithoutRender({value: props.data.id, key: props?.containerId}));
            window.newMicroFrontendData = { ...props,url1, store: {...formStateStore.getState(), iformClientLoaded: false}, resizeSubFormData: obj, authData: {
              Authorization: axios.defaults.headers.common["Authorization"],
              ngsmtoken: axios.defaults.headers.common["ngsmtoken"],
              cabinetName: axios.defaults.headers.common["cabinetName"],
            } };
            let res = true;
            if(window.subFormPreHook){
              res = window.subFormPreHook(getHooksId(props?.data));
              functions.updateJSON();
            }
            if (res !== false) {
              const newWin = window.open(`${url.origin}/psh/afb_subform`, '_blank', windowFeatures);
              // Wait for the new window to load
              if (newWin) {
                newWin.onload = function () {
                handleWinObjects(newWin);
                functions.addWindowObject(newWin);
                  // Copy functions from window.opener to newWin's window object
                  // Object.assign(event.currentTarget, window.opener);
                };
              } else {
                console.error("Popup blocked or failed to open.");
              }
            }
          }
        })
        .catch(error => { 
          console.error('There was a problem with the fetch operation:', error);
        })
      }
      else {
      let res = true;
      if (window.subFormPreHook) {
        res = window.subFormPreHook(getHooksId(props?.data));
        functions.updateJSON();
      }
      if (res !== false) {
        setOpenSub(true);  
        applyChanges(props.data.subform);
        dispatch(updateStateInRedux({name: "openSubformCheck", key: props?.containerId, value: "subform"}));
        dispatch(updatesubFormMetaDataWithoutRender({value: props.data.id, key: props?.containerId}));
        setSubFormState(props.data.subform);
      }
    }
      }      
    } else if (props?.data?.style?.ButtonLink && props.data.selectedEvent === 'link') {
      window.open(props.data.style.ButtonLink);
    }   

    if (
      props.data &&
      props.data.businessfunction &&
      props.data.businessfunction.BusinessFunctions
    ) {
      if (window.webServicePreHook) {
        if (!window.webServicePreHook(getHooksId(props?.data))) {
          return;
        }
        functions.updateJSON();
      }

      executeRestApi(
        props.data.businessfunction.BusinessFunctions[0]?.name,
        props.data?.id,
        "Click",
        reduxContexts.gdtoken,
        reduxContexts.witoken
      )
        .then((response) => {
          if (response && response.data && response.data.status === "0") {
            var apiArray = response.data.APIData;
            if (apiArray != null)
              renderExecuteServerEventAPIData({
                outputArray: apiArray,
                isCalledFromDBLinking: false,
                event: "Click",
                index: 0,
                sync: true,
                renderFlag : true
              });
          }
        })
        .catch((err) => {
          console.log("ExecuteAPI Failed");
        });
    }
  }

  const [editLabel, setEditLabel] = useState(false);

  const bringEditableLabel = (event) => {
    setEditLabel(true);
  };

  const inlineStyle = { ...buttonDefault.current };
  const inlineGroupStyle2 = { ...inlineStyle2.current };

  const iconStyle = {
    height: inlineStyle["font-size"],
    width: inlineStyle["font-size"],
    verticalAlign: "baseline",
    marginRight: "6px",
  };
  let endIconComp;

  endIconComp = (
    <>
      {props.data.style &&
      data.style.IconAlignment &&
      data.style.IconAlignment === "Right"
        ? iconFile.current && (
            <img
              className={iconStyle}
              src={`${(props.data.isWizardHeader || props.data.style.dynamicIcon) ? "" : imageBaseURL}${iconFile.current}${loadArabicImage(imageBaseURL)}`}
              style={{
                width: inlineStyle["font-size"].replace("!important", ""),
                height: inlineStyle["font-size"].replace("!important", ""),
                // marginLeft: props?.data?.style?.Label ? "4px" : null
                marginLeft: (window?.psh_configs?.selectedLanguage !== "ar" && props?.data?.style?.Label) ? "4px" : null,
                marginRight: (window?.psh_configs?.selectedLanguage === "ar" && props?.data?.style?.Label) ? "4px" : null
              }}
              alt="Button Icon"
            />
          )
        : null}
      {props?.data?.style?.ToolTip ? (
        <Tooltip
          iconVariant={
            props.data?.style?.ButtonType === "Primary" || !props.data?.style?.ButtonType ? "light" : "dark"
          }
           tooltip={
                                                <div style={{ direction: window?.psh_configs?.selectedLanguage === "ar" ? "rtl" : "ltr" }}>
                                                  {props?.data?.style.ToolTip}
                                                </div>
                                              }
          buttonStyle={{display:"inline-flex"}}
        />
      ) : null}
    </>
  );
  const [toggleButton, setToggleButton] = useState(false);
  // useEffect((previous) => {
  //   setToggleButton(!previous);
  // }, []);

  
  /******start*****************************UPDATING ENCRPTED DBQUERY STRING IN CASE IT IS ENC USING OLD METHODS******************************************* */
//   const [decr_dbquery, setdecr_dbquery]= useState( || "");
const [encr_dbquery_new, setencr_dbquery_new]= useState( undefined);

const encr_dbquery_new_temp= useRef({});

const encr_length_count= useRef(0);


async function getDecryptedstr( encr_str , key ){
  if(encr_str && key){
    const decr_str = await decryptMessage(encr_str , updateEncypted_str , key );
    // setdecr_dbquery(decr_str);
  }
}

async function updateEncypted_str(decr_str, key ){
  console.log("updateEncypted_str called textbox");
  
  let getcallbackstr = await decr_str;
  const encr_str_new = await encrypt(getcallbackstr);

  encr_dbquery_new_temp.current = {
          ...encr_dbquery_new_temp.current, 
          [key] : encr_str_new 
      };

  let newEventobj = JSON.parse( JSON.stringify( props.data.event.Events ) );

  if( encr_length_count.current === Object.keys( encr_dbquery_new_temp.current ).length ){

      let changedEventObj = newEventobj;

      for(let i=0; i< Object.keys( newEventobj ).length ; i++) {

          const eventName = Object.keys( newEventobj )[i];

          if(Array.isArray(newEventobj[eventName]?.DBLinking)){

              changedEventObj ={ ...changedEventObj, 
                  [ eventName ] : {...newEventobj[eventName], 
                      "DBLinking": newEventobj[eventName].DBLinking.map( (dbObj, j) => ({
                          ...dbObj,
                          "Query": encr_dbquery_new_temp.current[ eventName + "_" + j ] || dbObj?.Query
                      }) )
                  } }
                  
          }
      }
      
      setencr_dbquery_new(changedEventObj);
  }
}

  useEffect(()=>{
    if(props.previewmode){
    }
    else{
      if(props?.data?.event?.Events){

        const newEventobj = JSON.parse( JSON.stringify( props.data.event.Events ) );

        Object.keys(newEventobj).map((eventName) =>{

          const dbLinkingArr = Array.isArray(newEventobj[eventName]?.DBLinking) ? newEventobj[eventName].DBLinking : [];

          dbLinkingArr.forEach((dbObj, j) => {

            if(dbObj?.Query){
              encr_length_count.current = encr_length_count.current +1;
              getDecryptedstr( dbObj.Query , eventName + "_" + j );
            }

          })

        })
      }
    }
    
  },[])

  useEffect(()=>{
    if(props?.previewmode){
    }
    else{

        // updateformstate here 
        if(props?.data?.event?.Events && encr_dbquery_new){
            let old_control_json = JSON.parse( JSON.stringify( props?.data ) );
            old_control_json.event.Events = encr_dbquery_new;
            updatePartialJSON( old_control_json.id, old_control_json);
          }
      }
    
  },[encr_dbquery_new])


/******end*****************************UPDATING ENCRPTED DBQUERY STRING IN CASE IT IS ENC USING OLD METHODS******************************************* */



  function closeSubformOnPreview() {
    dispatch(
      updateGridContexts({
        name: "openCanvasForPreview",
        key: props.containerId,
        value: "",
      })
    );
  }

  if (props.previewmode) {
    return (
      
          <>
            <Form.Group
              className={styles2.formStyle}
              style={
                mobileDisplay === false || tabDisplay === false || props?.data?.style?.["Visible"]==="false" || props?.data?.style?.["Visible"]===false
                  ? { display: "none" }
                  : inlineGroupStyle2
              }
              key={props.id}
              id={userDefinedControlId + "_group"}
              frameindex={props.data.frameIndex}
              elementindex={props.data.elementIndex}
              sheetIndex={props.data.sheetIndex}
              sheetElementIndex={props.data.sheetElementIndex}
              sheetFrameElementindex={props.data.sheetFrameElementindex}
            >
              <PrepareCSSClass stylingData={themeStyle} />
              {alertData.open === true && (
                <CustomizedAlert alertData={alertData} />
              )}

              <Button
              tabIndex={activeTabIndex}
                id={userDefinedControlId}
                control_id={userDefinedControlId}
                disabled={
                  props?.data?.style?.Enable === "false" ||
                  props?.data?.style?.Enable === false
                }
                ref={elementRefrence}
                onClick={(event) => {
                  if(props?.data?.isButtonDropDown) { handleDropdownClick(event) }
                  else { subformInPreview(event) }
                }}
                size="small"
                style={inlineStyle}
                className={
                  `${props.id}` +
                  "buttonDefaultStyle" +
                  " formBuilder-MuiButton-outlined"
                }
                elem_type="button"
                frameindex={props.data.frameIndex}
                elementindex={props.data.elementIndex}
                disableElevation
                classes={{
                  root: classes.buttonLabel,
                }}
                variant={
                  inlineStyle.buttonType === "Primary"
                    ? "contained"
                    : inlineStyle.buttonType === "Secondary"
                    ? "outlined"
                    : ""
                }
                color={inlineStyle.buttonType === "Primary" ? "primary" : ""}
                startIcon={
                  props.data.style &&
                  data.style.IconAlignment &&
                  data.style.IconAlignment === "Left"
                    ? iconFile.current && (
                        <img
                          className={iconStyle}
                          src={`${(props.data.isWizardHeader || props.data.style.dynamicIcon) ? "" : imageBaseURL}${iconFile.current}${loadArabicImage(imageBaseURL)}`}
                          style={{
                            width: inlineStyle["font-size"].replace(
                              "!important",
                              ""
                            ),
                            height: inlineStyle["font-size"].replace(
                              "!important",
                              ""
                            ),
                            marginRight: (window?.psh_configs?.selectedLanguage !== "ar" && props?.data?.style?.Label) ? "4px" : null,
                            marginLeft: (window?.psh_configs?.selectedLanguage === "ar" && props?.data?.style?.Label) ? "4px" : null
                          }}
                          alt="Button Icon"
                        />
                      )
                    : null
                }
                endIcon={iconFile.current || props?.data?.style?.ToolTip  ? endIconComp : props?.data?.isButtonDropDown ? <span style={{display: "flex",transform: openDropdown ? 'rotate(180deg)' : 'rotate(0deg)'}}><DropdownIcon /></span> : null}
              >
                <div
                  className={
                    inlineStyle.buttonType == "Text" ? styles3.buttonHover : ""
                  }
                >
                  {props?.data?.style["Label"]}
                </div>
              </Button>
              {props?.data?.isButtonDropDown && (
                <Menu
                  getContentAnchorEl={null}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                  }}
                  anchorEl={anchorEl}
                  open={openDropdown}
                  onClose={handleDropdownClose}
                >
                  {buttonOptionsLabel.length > 0 &&
                    buttonOptionsLabel.map((option) => (
                      <MenuItem
                        key={option}
                        onClick={() => {
                          if (typeof buttonOptionsJSON[option] === "function") {
                            buttonOptionsJSON[option]();
                          }
                          handleDropdownClose();
                        }}
                      >
                        {option}
                      </MenuItem>
                    ))}
                </Menu>
              )}
              {props.data && props.data.subform && openSub &&(
                <ButtonSubFormDialog
                  userDefinedControlId={userDefinedControlId}
                  open={openSub}
                  setOpenSub={setOpenSub}
                  subFormData={props?.data?.subform || subFormStateJson}
                  {...props}
                />
              )}
              {getPicklistDataPopup && (
                <PickListPopup
                  open={true}
                  onClose={(data, rowSelect, selected, picklistSelectedData) => {
                    if (rowSelect !== undefined && rowSelect !== -1 && data?.[rowSelect]) {
                      props.data._picklistSelection = {
                        Picklist: data[rowSelect][0],
                        PicklistSelected: rowSelect,
                        PicklistSelectedAllData: picklistSelectedData || {},
                      };
                    }
                    setGetPicklistDataPopup(null);
                  }}
                  onClose2={() => setGetPicklistDataPopup(null)}
                  data={getPicklistDataPopup}
                  style={getPicklistDataPopup.style}
                  containerId={props.containerId}
                />
              )}
            </Form.Group>

            {openCanvasForPreview === "subform" && (
              <CanvasSubform
                {...props}
                subFormData={props.subFormData}
                openCanvasForPreview={openCanvasForPreview}
                closeSubformOnPreview={closeSubformOnPreview}
              />
            )}
          </>        
    );
  } else {
    return (
      <Form.Group
        onClick={
          isSubformInPage
            ? () => {}
            : (e) => props.handleSelected(e, props.data.id, "n")
        }
        style={inlineGroupStyle2}
        onDoubleClick={bringEditableLabel}
        onKeyDown={(e) => props.handleSelected(e)}
        control_id={props.id}
        className={styles2.formStyle}
        key={props.id}
        id={userDefinedControlId + "_group"}
        frameindex={props.data.frameIndex}
        elementindex={props.data.elementIndex}
        sheetIndex={props.data.sheetIndex}
        sheetElementIndex={props.data.sheetElementIndex}
        sheetFrameElementindex={props.data.sheetFrameElementindex}
        tabIndex={activeTabIndex}
      >
        <PrepareCSSClass stylingData={themeStyle} />
        <Button
        tabIndex={activeTabIndex}
          id={userDefinedControlId}
          disableRipple={disableBtn}
          onDoubleClick={bringEditableLabel}
          control_id={props.data.id}
          size="small"
          classes={{
            root: classes.buttonLabel,
          }}
          className={`${classes.test} ${props.id}buttonDefaultStyle formBuilder-MuiButton-outlined`}
          style={{
            ...inlineStyle,
            fontSize: `${
              props?.data?.style["FontSize"]
                ? props?.data?.style["FontSize"]
                : "12px !important"
            }`,
            pointerEvents:"none"
          }}
          elem_type="button"
          frameindex={props.data.frameIndex}
          elementindex={props.data.elementIndex}
          disableElevation
          variant={
            inlineStyle.buttonType === "Primary"
              ? "contained"
              : inlineStyle.buttonType === "Secondary"
              ? "outlined"
              : ""
          }
          color={inlineStyle.buttonType === "Primary" ? "primary" : ""}
          startIcon={
            props.data.style &&
            data.style.IconAlignment &&
            data.style.IconAlignment === "Left"
              ? iconFile.current && (
                  <img
                    className={iconStyle}
                    src={`${(props.data.isWizardHeader || props.data.style.dynamicIcon) ? "" : imageBaseURL}${iconFile.current}${loadArabicImage(imageBaseURL)}`}
                    style={{
                      width: inlineStyle["font-size"].replace("!important", ""),
                      height: inlineStyle["font-size"].replace(
                        "!important",
                        ""
                      ),
                      marginRight: (window?.psh_configs?.selectedLanguage !== "ar" && props?.data?.style?.Label) ? "4px" : null,
                      marginLeft: (window?.psh_configs?.selectedLanguage === "ar" && props?.data?.style?.Label) ? "4px" : null
                    }}
                    alt="Button Icon"
                  />
                )
              : null
          }
          endIcon={iconFile.current || props?.data?.style?.ToolTip ? endIconComp : null}
        >
          {props?.data?.style["Label"]}
        </Button>
        {controlSelected?.id === props?.id && (
          <ElemDeleteControl
            isSubformInPage={isSubformInPage}
            containerId={props.containerId}
            id={props.data.id}
            deleteControl={deleteControl}
            elemType={props.data.elem_type}
            setDragging={props.setDragging}
            handleReorderStart={props.handleReorderStart}
            handleReorderDrop={props.handleReorderDrop}
            data={props.data}
            dragId={props.dragId}
            dragType={"column"}
          />
        )}
        {window?.openQuickTools && open && (
          <QuickTools
            containerId={props.containerId}
            selectedControl={props.data}
            open={open}
            setOpen={setOpen}
          />
        )}
      </Form.Group>
    );
  }
};

export default BUTTON;
